export default {
    // 消息中间件信息查询接口
    listUserInfos(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getAllUsers', params, response);
    },
    // 获取用户信息
    getUserInfos(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserInfos', params, response);
    },
    // 消息中间件删除接口
    deleteUserInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/deleteUserInfo', params, response);
    },
    // 消息添加接口
    insertUserInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/insertUserInfo', params, response);
    },
    // 更新扩展信息
    updateUserExtend(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/updateUserExtend', params, response);
    },
    // 消息中间件信息查询接口
    getRoleInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getRoleInfo', params, response);
    },
    getUserRole(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserRole', params, response);
    },
    getUserRoleInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserRoleInfo', params, response);
    },
    // 消息中间件信息查询接口
    getUserExtends(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserExtends', params, response);
    },
    getUserExtendsValues(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserExtendsValues', params, response);
    },
    getUserInfoByName(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserInfoByName', params, response);
    },
    // 消息中间件信息查询接口
    checkUserInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/authCtrl/login', params, response);
    },
    // 消息更新接口
    getSysList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/sys/getSysList', params, response);
    },
    // 获取菜单信息
    getOrgList(url, hostName, params, response) {
        window.vue.$apiAxios.postRequestBody(url, params, response, hostName);
    },
    // 消息中间件信息查询接口
    getUserIpList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserIpList', params, response);
    },
    // 消息中间件信息查询接口
    getUserMacList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserMacList', params, response);
    },
    // 获取菜单信息
    exportExcel(params, requestType, response) {
        window.vue.$apiAxios.download('/auth/user/exportExcel', params, requestType, response);
    },
    // 重置密码
    resetPassword(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/resetPassword', params, response);
    },
    // 获取用户权限信息
    getUserAuthInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserAuthInfo', params, response);
    }
};
